//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { EventLocationDisplayItem } from './EventLocationDisplayItem';

export class TeacherAvailabilityLocationDisplayItem extends ItemBase {
    TeacherAvailabilityID: string | null = null;
    EventLocationID: string | null = null;
    EventLocation: EventLocationDisplayItem | null = null;
    Priority: number = 0;

    constructor(initializer?: Partial<TeacherAvailabilityLocationDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherAvailabilityLocationDisplayItem";
}
